import React, { useState, useMemo } from "react";
import "@styles/pages/Login/Samsung/SamsungAccountLogin.scss";
import { Box, TextField, Button, Typography, Paper } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams, useLocation } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { redirectToSamsungLoginPage } from "@utils/redirectToSamsungLoginPage";
import { gaEvent } from "@utils/gaEvent";

const SamsungAccountLogin = () => {
  const utmId = localStorage.getItem("utm_id");
  const host = window.location.hostname;
  const index = useMemo(() => {
    if (host === "localhost") {
      return "LocalIndex";
    } else {
      return "Index";
    }
  }, []);

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const handleSamsungLogin = async () => {
    gaEvent("clubs_signup", "sign_up_page", "login_next");

    // ✅ 給 GA 一點時間把 beacon / request dispatch 出去
    await sleep(1000);

    redirectToSamsungLoginPage({ index, ...(utmId ? { id: utmId } : {}) });
  };
  return (
    <Box className="samsung-account-login-container">
      <Button
        onClick={() => {
          handleSamsungLogin();
        }}
        className="button samsung-button"
        fullWidth
      >
        <Trans i18nKey="login:samsung_login" />
      </Button>
    </Box>
  );
};

export default SamsungAccountLogin;
